<aside class="sidebar">
  <div class="sidebar__head">
    <a class="sidebar__logo" href="#" aria-label="BELTURO">
      <svg width="34" height="34" viewBox="0 0 120 120" fill="none" aria-hidden="true">
        <defs>
          <clipPath id="alFrame"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
        </defs>
        <rect x="26" y="18" width="68" height="84" rx="18" stroke="#F2E9DC" stroke-width="4.5"></rect>
        <g clip-path="url(#alFrame)">
          <circle cx="46.5" cy="44" r="8.5" stroke="#D6C59D" stroke-width="3.6"></circle>
          <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#F2E9DC" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
          <path d="M26 87 Q43 79 60 87 T95 87" stroke="#D6C59D" stroke-width="3.6" stroke-linecap="round"></path>
          <path d="M26 96 Q45 87 62 96 T98 95" stroke="#D6C59D" stroke-width="3.6" stroke-linecap="round"></path>
        </g>
      </svg>
      <span class="sidebar__word">Belturo</span>
    </a>
  </div>

  <nav class="sidebar__nav">
    <div class="nav-group">
      <div class="nav-group__title"><%= _lcs( 'Home' ) %></div>
      <a class="nav-item nav-item--active" href="#" title="<%= _lcs( 'Übersicht' ) %>" data-route="/">
        <span class="nav-item__icon"><i class="icon icon--layout-dashboard"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Übersicht' ) %></span>
      </a>
      <!--
      <a class="nav-item" href="#" title="<%= _lcs( 'Aktivität' ) %>">
        <span class="nav-item__icon"><i class="icon icon--activity"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Aktivität' ) %></span>
      </a>
      -->
      <a class="nav-item" href="#" title="<%= _lcs( 'Analytics' ) %>" data-route="/analytics">
        <span class="nav-item__icon"><i class="icon icon--bar-chart-3"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Analytics' ) %></span>
      </a>
    </div>

    <div class="nav-group">
      <div class="nav-group__title"><%= _lcs( 'Clients' ) %></div>
      <a class="nav-item" href="#" title="<%= _lcs( 'Gastgeber' ) %>" data-route="/client/users">
        <span class="nav-item__icon"><i class="icon icon--briefcase"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Gastgeber' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Unterkünfte' ) %>" data-route="/client/accommodation">
        <span class="nav-item__icon"><i class="icon icon--building-2"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Unterkünfte' ) %></span>
      </a>
      <a class="nav-item nav-item--disabled" href="#" title="<%= _lcs( 'Abonnements' ) %>" aria-disabled="true">
        <span class="nav-item__icon"><i class="icon icon--badge-euro"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Abonnements' ) %></span>
      </a>
      <a class="nav-item nav-item--disabled" href="#" title="<%= _lcs( 'Rechnungen' ) %>" aria-disabled="true">
        <span class="nav-item__icon"><i class="icon icon--receipt"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Rechnungen' ) %></span>
      </a>
    </div>

    <div class="nav-group">
      <div class="nav-group__title"><%= _lcs( 'Guests' ) %></div>
      <a class="nav-item" href="#" title="<%= _lcs( 'Gästekonten' ) %>" data-route="/guest/users">
        <span class="nav-item__icon"><i class="icon icon--user-round"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Gästekonten' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Push-Nachrichten' ) %>" data-route="/guest/push">
        <span class="nav-item__icon"><i class="icon icon--bell-ring"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Push-Nachrichten' ) %></span>
      </a>
    </div>

    <div class="nav-group">
      <div class="nav-group__title"><%= _lcs( 'Region' ) %></div>
      <a class="nav-item" href="#" title="<%= _lcs( 'Veranstaltungen' ) %>" data-route="/events">
        <span class="nav-item__icon"><i class="icon icon--calendar-days"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Veranstaltungen' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Sehenswürdigkeiten' ) %>" data-route="/sights">
        <span class="nav-item__icon"><i class="icon icon--landmark"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Sehenswürdigkeiten' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Gastronomie' ) %>" data-route="/gastronomy">
        <span class="nav-item__icon"><i class="icon icon--utensils"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Gastronomie' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Touren' ) %>" data-route="/tours">
        <span class="nav-item__icon"><i class="icon icon--route"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Touren' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Datenquellen' ) %>" data-route="/sources">
        <span class="nav-item__icon"><i class="icon icon--layers"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Datenquellen' ) %></span>
      </a>
    </div>

    <div class="nav-group">
      <div class="nav-group__title"><%= _lcs( 'System' ) %></div>
      <a class="nav-item" href="#" title="<%= _lcs( 'Benutzer' ) %>" data-route="/admin/users">
        <span class="nav-item__icon"><i class="icon icon--users"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Benutzer' ) %></span>
      </a>
      <!--
      <a class="nav-item" href="#" title="<%= _lcs( 'Feature-Flags' ) %>">
        <span class="nav-item__icon"><i class="icon icon--flag"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Feature-Flags' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Systemzustand' ) %>">
        <span class="nav-item__icon"><i class="icon icon--heart-pulse"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Systemzustand' ) %></span>
      </a>
      -->
      <a class="nav-item" href="#" title="<%= _lcs( 'KI-Kosten' ) %>" data-route="/admin/ai-costs">
        <span class="nav-item__icon"><i class="icon icon--sparkles"></i></span>
        <span class="nav-item__label"><%= _lcs( 'KI-Kosten' ) %></span>
      </a>
      <a class="nav-item" href="#" title="<%= _lcs( 'Protokolle' ) %>" data-route="/admin/logs">
        <span class="nav-item__icon"><i class="icon icon--scroll-text"></i></span>
        <span class="nav-item__label"><%= _lcs( 'Protokolle' ) %></span>
      </a>
    </div>
  </nav>
</aside>
